<!-- <span *ngIf="invoiceLineItem._isTax" class="tax-icon">{{ 'invoices.invoice-builder.line-items-tab.tax' | translate | titlecase }}</span> -->
<div class="mct-flex mct-row mct-gap-80"  >
  <div class="field-column-left mct-flex mct-col" >
    <div class="mct-flex mct-col" >
      <label>{{ 'invoices.invoice-builder.line-items-tab.revenue-item' | translate | titlecase }}</label>
      <p-select
        optionLabel="ItemName"
        dataKey="ItemNum"
        placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
        [options]="activeRevenueItems"
        [style]="{ width: '100%' }"
        [(ngModel)]="selectedRevenueItem"
        (onChange)="onSelectedRevenueItemChange($event)"
        [disabled]="invoiceLineItem.Posted"
      ></p-select>
    </div>
    <div class="mct-flex mct-col" >
      <label>{{ 'invoices.invoice-builder.line-items-tab.apply-date' | translate | titlecase }}</label>
      <wl-date-selector [(ngModel)]="invoiceLineItem.ApplyDate" [disabled]="invoiceLineItem.Posted"></wl-date-selector>
    </div>
    <div class="mct-flex mct-row mct-gap-7"  >
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.line-items-tab.service-period-start' | translate | titlecase }}</label>
        <wl-date-selector [(ngModel)]="invoiceLineItem.ServicePeriod_StartPeriod"></wl-date-selector>
      </div>
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.line-items-tab.service-period-end' | translate | titlecase }}</label>
        <wl-date-selector [(ngModel)]="invoiceLineItem.ServicePeriod_EndPeriod"></wl-date-selector>
      </div>
    </div>
    <div class="mct-flex mct-row mct-gap-7"  >
      <div class="mct-flex mct-col mct-flex-1-1-0"  >
        <label class="mct-flex mct-row mct-justify-start mct-items-center"
          ><i class="pi pi-times"></i> {{ 'invoices.invoice-builder.line-items-tab.unit-price' | translate | titlecase }}</label
        >
        <p-inputgroup>
          <p-inputgroup-addon>$</p-inputgroup-addon>
          <input
            pInputText
            (input)="invoiceAmountChanged()"
            [(ngModel)]="invoiceLineItem.UnitPrice"
            type="number"
            [disabled]="invoiceLineItem.Posted"
          />
        </p-inputgroup>
      </div>
      <div class="mct-flex mct-col mct-flex-1-1-0"  >
        <label>{{ 'invoices.invoice-builder.line-items-tab.quantity' | translate | titlecase }}</label>
        <input
          pInputText
          (input)="invoiceAmountChanged()"
          [(ngModel)]="invoiceLineItem.Quantity"
          type="number"
          [disabled]="invoiceLineItem.Posted"
        />
      </div>
    </div>
    <div class="mct-flex mct-row mct-gap-7"  >
      <a class="mct-flex-1-1-0"  *ngIf="!showBasePriceField" (click)="showBasePriceField = true">{{
        'invoices.invoice-builder.line-items-tab.add-a-base-price' | translate | ucfirst
      }}</a>
      <div class="mct-flex mct-col mct-flex-1-1-0"  *ngIf="showBasePriceField" >
        <label class="mct-flex mct-row mct-justify-start mct-items-center"
          ><i class="pi pi-plus"></i> {{ 'invoices.invoice-builder.line-items-tab.base-price' | translate | titlecase }}
        </label>
        <p-inputgroup>
          <p-inputgroup-addon>$</p-inputgroup-addon>
          <input
            pInputText
            (input)="invoiceAmountChanged()"
            [(ngModel)]="invoiceLineItem.BasePrice"
            type="number"
            [disabled]="invoiceLineItem.Posted"
          />
        </p-inputgroup>
      </div>
      <a class="mct-flex-1-1-0"  *ngIf="!showFlatFeeField" (click)="showFlatFeeField = true">{{
        'invoices.invoice-builder.line-items-tab.add-a-flat-fee' | translate | ucfirst
      }}</a>
      <div class="mct-flex mct-col mct-flex-1-1-0"  *ngIf="showFlatFeeField" >
        <label class="mct-flex mct-row mct-justify-start mct-items-center"
          ><i class="pi pi-plus"></i> {{ 'invoices.invoice-builder.line-items-tab.flat-fee-price' | translate | titlecase }}</label
        >
        <p-inputgroup>
          <p-inputgroup-addon>$</p-inputgroup-addon>
          <input
            pInputText
            (input)="invoiceAmountChanged()"
            [(ngModel)]="invoiceLineItem.FlatFee"
            type="number"
            [disabled]="invoiceLineItem.Posted"
          />
        </p-inputgroup>
      </div>
    </div>
  </div>
  <div class="field-column-right mct-flex mct-col" >
    <div class="mct-flex mct-row mct-justify-between mct-items-start mct-gap-7"   >
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.line-items-tab.description' | translate | titlecase }}</label>
        <textarea maxlength="500" [(ngModel)]="invoiceLineItem.Descr" style="height: 120px" pInputTextarea></textarea>
      </div>
      <div class="mct-flex mct-col" >
        <div>
          <label>{{ 'invoices.invoice-builder.line-items-tab.line-item-id' | translate }}</label>
          <input class="form-control" [disabled]="true" [ngModel]="invoiceLineItem.LineItemId" />
        </div>
        <div class="mt-27 mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.line-items-tab.sold-by' | translate | titlecase }}</label>
          <p-select
            placeholder="{{ 'invoices.invoice-builder.none-label' | translate }}"
            [options]="soldBySelectItems"
            [(ngModel)]="invoiceLineItem.SoldBy"
            [style]="{ width: '100%' }"
          ></p-select>
        </div>
      </div>
    </div>
    <div class="mct-flex mct-row mct-gap-7"   [hidden]="!invoiceLineItem.Batch_Creation || invoiceLineItem.BillingId <= 0">
      <div>
        <div [hidden]="!invoiceLineItem.Batch_Creation">
          <label>{{ 'invoices.invoice-builder.line-items-tab.batch-number' | translate | titlecase }}</label>
          <div>
            <input class="form-control" [disabled]="true" [ngModel]="invoiceLineItem.Batch_Creation" />
          </div>
        </div>
      </div>
      <div class="mct-flex mct-col"  [hidden]="invoiceLineItem.BillingId <= 0">
        <label>{{ 'invoices.invoice-builder.line-items-tab.billing-id' | translate }}</label>
        <input class="form-control" [disabled]="true" [ngModel]="invoiceLineItem.BillingId" />
      </div>
    </div>
    <div class="mct-flex mct-row mct-gap-7"  >
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.line-items-tab.debit-account' | translate | titlecase }}</label>
        <input class="form-control" [disabled]="true" [ngModel]="debitAccount" />
      </div>
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.line-items-tab.credit-account' | translate | titlecase }}</label>
        <input class="form-control" [disabled]="true" [ngModel]="creditAccount" />
      </div>
    </div>
  </div>
</div>
<div class="mct-flex mct-row mct-justify-between mct-items-center"  >
  <span class="mt-27">
    <strong>=</strong> {{ 'invoices.invoice-builder.line-items-tab.adjusted-amount-due' | translate | titlecase }}:
    <strong>{{ adjustedAmountDue | atlasCurrency }}</strong>
    <a class="ml-20" (click)="detailsDialog.open(invoice, invoiceLineItem.LineItemId)" data-pendo="lineItemViewDetailsLink">{{
      'invoices.invoice-builder.line-items-tab.view-details' | translate | ucfirst
    }}</a>
  </span>
  <div class="mct-flex mct-row mct-justify-end mct-items-center"  >
    <span *ngIf="invoiceLineItem.Posted" class="card-field-label"
      >{{ 'invoices.invoice-builder.line-items-tab.line-item-posted' | translate | titlecase }}
      {{ invoiceLineItem.DatePosted | date : 'MM/dd/yyyy' }}</span
    >&nbsp;
    <button


      class="btn btn-secondary mct-flex mct-row mct-justify-start mct-items-center"
      type="button"
      (click)="removeClicked.emit()"
      [disabled]="invoiceLineItem.Posted"
    >
      <i class="pi pi-times"></i>
      {{ 'invoices.invoice-builder.line-items-tab.remove-line-item' | translate | uppercase }}
    </button>
  </div>
</div>

<div *ngIf="invoiceLineItem.TaxLineItems && invoiceLineItem.TaxLineItems.length > 0">
  <div *ngFor="let lineItem of invoiceLineItem.TaxLineItems; index as i">
    <hr />
    <wl-invoice-line-item
      [invoice]="invoice"
      [invoiceLineItem]="lineItem"
      [allUsers]="allUsers"
      [allRevenueItems]="allRevenueItems"
      (removeClicked)="removeTaxLineItem(i)"
    ></wl-invoice-line-item>
  </div>
</div>

<wl-invoice-line-item-details-dialog #detailsDialog></wl-invoice-line-item-details-dialog>
